import {useAtom} from 'jotai';
import {Cookie} from 'lucide-react';
import {cookieConsentAtom} from '@lib/atoms';
import {Button} from '@ui/shadcn/button';

const POLICY_URL =
  'https://drive.google.com/file/d/1sqjxRxU2yPtR-cGJOREB_JlJny0iIzny/view?usp=sharing';

/**
 * Нижний баннер согласия на cookies (раунд 25 §1 + раунд 26 правка).
 * Растянут на всю ширину окна, прижат к нижней кромке.
 */
export const CookieBanner = () => {
  const [accepted, setAccepted] = useAtom(cookieConsentAtom);

  if (accepted) return null;

  return (
    <div
      role='region'
      aria-label='Согласие на использование cookies'
      className='fixed left-0 right-0 bottom-0 flex items-center gap-3 px-4 md:px-6 py-3 bg-[var(--color-surface)] border-t border-[var(--color-border)] shadow-2xl'
      style={{zIndex: 'var(--z-toast)'}}
    >
      <span className='w-8 h-8 rounded-lg bg-[var(--color-primary-soft)] text-[var(--color-primary)] flex items-center justify-center shrink-0'>
        <Cookie size={16} />
      </span>
      <p className='flex-1 text-xs sm:text-sm text-[var(--color-foreground)] leading-relaxed min-w-0'>
        Мы используем cookies для входа и настроек, а также фиксируем
        технические данные об использовании сервиса: время входа и активности,
        устройство, браузер и ОС, IP-адрес, подключение мессенджеров и доставку
        уведомлений. Эти данные видят администратор вашей компании и
        руководители в пределах своей команды. Подробнее — в{' '}
        <a
          href={POLICY_URL}
          target='_blank'
          rel='noopener noreferrer'
          className='text-[var(--color-primary)] hover:underline font-medium'
        >
          Политике cookie
        </a>
        .
      </p>
      <Button
        type='button'
        size='sm'
        onClick={() => setAccepted(true)}
        className='shrink-0'
      >
        Принять
      </Button>
    </div>
  );
};
